import { baseGet, basePost } from "services/base-services/baseService";
import { API2_HOST } from 'helpers/urlHelper';

const sanitizeGrn = (grn) => {
  if (grn === null || grn === undefined) return '';
  const asString = grn.toString();
  const digitsOnly = asString.replace(/[^\d]/g, '');
  return digitsOnly || asString;
};

export const getWpoLines = async (wpoNo) => {
  return await baseGet(`${API2_HOST}/sls-wpo`, wpoNo);
};

export const submitBookingIn = async (poId, payload) => {
  return await basePost(`${API2_HOST}/sls-wpo/${poId}/stk-trans`, payload);
};

export const sendMailDiscrepancy = async (poId, grnNo, items = [], delNoteRef, receiptDate) => {
  const cleanGrn = sanitizeGrn(grnNo);
  if (!cleanGrn) throw new Error('GRN number is missing');
  return await basePost(`${API2_HOST}/sls-wpo/send-mail/${poId}/${cleanGrn}`, {
    Items: items,
    DelNoteRef: delNoteRef,
    ReceiptDate: receiptDate
  });
};

export const saveIncorrectItems = async (poId, grnNo, items) => {
  // Body should be { items: [...] } based on SlsWpoIncorrectRQ
  const cleanGrn = sanitizeGrn(grnNo);
  if (!cleanGrn) throw new Error('GRN number is missing');
  return await basePost(`${API2_HOST}/sls-wpo/save-incorrect/${poId}/${cleanGrn}`, { items });
};
